module.exports = __webpack_public_path__ + "static/media/call-auth-advantage-trade.d8ace623.png";